module.exports = __webpack_public_path__ + "img/anatomic-model.4b2441ba.png";